
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAssociatedTargetRadarSelectedIec as ObiAssociatedTargetRadarSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-associated-target-radar-selected-iec.js';
 
 
 

 
 export const ObiAssociatedTargetRadarSelectedIec = createComponent({
   react: React,
   tagName: 'obi-associated-target-radar-selected-iec',
   elementClass: ObiAssociatedTargetRadarSelectedIecElement,
   events: {
     
   }
  });
 
 